import Api from 'components/app/Api'
import store from 'store'

class CrewView extends Api {
    /**
     * Constructor.
     * @param object data The data to create an instance with.
     */
     constructor(id = null) {
        super({
            id: id,
            apiUrl: 'api/crew',
            module: 'crewview',
        })
    }

    /**
     * Retrieve users that can be added as crew members on a Production.
     * @param object params
     * @return promise
     */
     static getAvailableProductions(params = {}) {
        const context = this
        return new Promise((resolve, reject) => {
            store.commit('removeData', {key: 'availableProductionsCrew'})
            axios.get('api/available-production-crew', {params: params})
                .then(response => {
                    store.commit('setData', {key: 'availableProductionsCrew', data: response.data, reset: true})
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

     /**
     * Retrieve users that can be added as crew members on a Production.
     * @param object params
     * @return promise
     */
      static getProductions(params = {}) {
        const context = this
        return new Promise((resolve, reject) => {
            store.commit('removeData', {key: 'production'})
            axios.get('api/available-production-crew', {params: params})
                .then(response => {
                    store.commit('setData', {key: 'production', data: response.data, reset: true})
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    /**
     * Retrieve users that can be added as crew members on a Production.
     * @param object params
     * @return promise
     */
     static getProblemProductions(params = {}) {
        const context = this
        return new Promise((resolve, reject) => {
            store.commit('removeData', {key: 'problemProductions'})
            axios.get('api/problem-production-crew', {params: params})
                .then(response => {
                    store.commit('setData', {key: 'problemProductions', data: response.data, reset: true})
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    /**
     * Retrieve users that can be added as crew members on a Production.
     * @param object params
     * @return promise
     */
     static setStatus(params = {}) {
        const context = this
        return new Promise((resolve, reject) => {
            //store.commit('removeData', {key: 'production'})
            axios.post('api/crew/apply-status', params)
                .then(response => {
                    // store.commit('setData', {key: 'production', data: response.data, reset: true})
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    /**
     * Retrieve users that can be added as crew members on a Production.
     * @param object params
     * @return promise
     */
     static addMultiAssignments(params = {}) {
        const context = this
        return new Promise((resolve, reject) => {
            //store.commit('removeData', {key: 'production'})
            axios.post('api/crew/apply-multi-assignments', params)
                .then(response => {
                    // store.commit('setData', {key: 'production', data: response.data, reset: true})
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

    /**
     * Retrieve users that can be added as crew members on a Production.
     * @param object params
     * @return promise
     */
     static replaceMultiAssignments(params = {}) {
        const context = this
        return new Promise((resolve, reject) => {
            //store.commit('removeData', {key: 'production'})
            axios.post('api/crew/replace-multi-assignments', params)
                .then(response => {
                    // store.commit('setData', {key: 'production', data: response.data, reset: true})
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }

}

export default CrewView;